var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SON",
    transform: "translate(-0.129)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(0.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "music-and-multimedia_1_",
    "data-name": "music-and-multimedia (1)",
    transform: "translate(13.231 13.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M18.833,16.1a1.077,1.077,0,0,0-1.143.13L7.181,24.633H2.16A2.164,2.164,0,0,0,0,26.794v8.642A2.163,2.163,0,0,0,2.16,37.6H7.181L17.688,46a1.082,1.082,0,0,0,1.145.127,1.078,1.078,0,0,0,.611-.972V17.072A1.084,1.084,0,0,0,18.833,16.1Z",
    transform: "translate(0 -15.99)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M343.591,122.563a1.081,1.081,0,1,0-1.519,1.538,8.617,8.617,0,0,1,0,12.2,1.079,1.079,0,1,0,1.519,1.534,10.776,10.776,0,0,0,0-15.274Z",
    transform: "translate(-318.679 -115.078)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M388.709,77.438a1.081,1.081,0,1,0-1.523,1.534,12.891,12.891,0,0,1,0,18.3,1.081,1.081,0,0,0,1.523,1.534,15.056,15.056,0,0,0,0-21.365Z",
    transform: "translate(-360.749 -72.997)",
    fill: "#868686"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSound);
export default __webpack_public_path__ + "static/media/icon_sound.111c9edb.svg";
export { ForwardRef as ReactComponent };